import { PILLAR, WELL, COUPLING, FOB, CABLE, PON_BOX } from "../Optics/Constants/ConstantsOptics";
import { Snackbar } from '@mui/material';
import CustomSnackbar from "../Optics/Components/CustomSnackbar";
import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import React, { useState} from "react";
import axios from 'axios';
import { DELETE_ADMIN_PILLAR_ID_API_URL, DELETE_ADMIN_WELL_ID_API_URL, DELETE_ADMIN_COUPLING_ID_API_URL,
    DELETE_ADMIN_FOB_ID_API_URL, DELETE_ADMIN_CABLE_ID_API_URL, DELETE_ADMIN_PONBOX_ID_API_URL, GET_ADMIN_COMPONENT_ID_API_URL} from "../Optics/OpticApiConfig";

const AdminDeleteComponent = ({ open, onClose }) => {

    const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();

    const [selectedComponent, setSelectedComponent] = useState('');
    const [inputId, setInputId] = useState('');
    const [data, setData] = useState([]);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const token = localStorage.getItem('token');

    const onCloseModal = async () => {
        setSelectedComponent('');
        setInputId('');
        setData([]);
        setIsDataLoaded(false);
        onClose();
    }

    const getDataComponents = async () => {
        setData([]);
        setIsDataLoaded(false);

        if(selectedComponent === '' || inputId === ''){
            showSnackbar('Пустой ID или тип компонента!!!', 'snackbarWarning');
            return;
        }
        try {
            const response = await axios.get(
                `${GET_ADMIN_COMPONENT_ID_API_URL}`,
                {
                    params: { id: inputId, flag: selectedComponent },
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}` 
                    }
                }
            );
    
            setData(response.data);
            setIsDataLoaded(response.data.length > 0);
        } catch (error) {
            console.error('Ошибка при получении данных:', error);
        }
    };


    
    const deleteComponents = async () => {
        let apiEndpoint = '';

        if (!token) {
            showSnackbar('Ошибка! Токен не найден', 'snackbarWarning');
            return;
        }

        switch (selectedComponent) {
            case PILLAR:
                apiEndpoint = `${DELETE_ADMIN_PILLAR_ID_API_URL}?pillarId=${inputId}`;
                break;
            case WELL:
                apiEndpoint = `${DELETE_ADMIN_WELL_ID_API_URL}?wellId=${inputId}`;
                break;
            case COUPLING:
                apiEndpoint = `${DELETE_ADMIN_COUPLING_ID_API_URL}?couplingLocationId=${inputId}`;
                break;
            case FOB:
                apiEndpoint = `${DELETE_ADMIN_FOB_ID_API_URL}?fobLocationId=${inputId}`;
                break;
            case CABLE:
                apiEndpoint = `${DELETE_ADMIN_CABLE_ID_API_URL}?highwayLineId=${inputId}`;
                break;
            case PON_BOX:
                apiEndpoint = `${DELETE_ADMIN_PONBOX_ID_API_URL}?ponBoxId=${inputId}`;
                break;
            default:
                showSnackbar('Выберите тип компонента', 'snackbarWarning');
                return;
        }

        try {
            const response = await fetch(apiEndpoint, { 
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}` 
                }
            });

            if (response.ok) {
                showSnackbar('Компонент успешно удален', 'snackbarWarning');
                setSelectedComponent('');
                setInputId('');
                setData([]);
                setIsDataLoaded(false);
            } else {
                showSnackbar('Ошибка удаления!', 'snackbarWarning');
            }
        } catch (error) {
            showSnackbar('Произошла ошибка!', 'snackbarWarning');
        }  
    };
    
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="lg" 
            PaperProps={{
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    padding: '20px',
                    overflowX: 'auto',
                },
            }}
            className="modalStyle"
        >
            <DialogContent>
            <label style={{ color: '#dfab01', fontSize: '20px', fontFamily: 'unset' }}>Удаление компонентов по ID</label>
                <hr className='horizontalLineModal' />
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <select
                        className="selectStyleModal"
                        value={selectedComponent}
                        style={{width:"200px", marginTop: "17px"}}
                        onChange={(e) => setSelectedComponent(e.target.value)}
                    >
                        <option value="">Тип компонента</option>
                        <option value={PILLAR}>Опора</option>
                        <option value={WELL}>Колодец</option>
                        <option value={COUPLING}>Муфта</option>
                        <option value={FOB}>Фоб</option>
                        <option value={CABLE}>Кабель</option>
                        <option value={PON_BOX}>Пон-бокс</option>
                    </select>
                    <br />

                    <input
                        type="number"
                        placeholder="Введите ID"
                        className='inputDeleteModal'
                        style={{width:"200px", marginTop: "10px"}}
                        value={inputId}
                        onChange={(e) => setInputId(e.target.value)}
                    />
                    <br />
                    <button className='buttonIsChangeModal' style={{width: "auto"}} onClick={getDataComponents}>Поиск</button>
                   
                    <hr className='horizontalLineModal' />
                </div>
                <br/>
                <div className="table-container">
                <table className="custom-table">
               
            <thead>
                <tr>
                    <th>Тип</th> 
                    <th>ID</th>                  
                    <th>Имя</th>
                    <th>Комент</th>
                    <th>Округ</th>
                    <th>Создано</th>
                    <th>Статус</th>
                    <th>Создал</th>                 
                    <th>Ранг</th>
                </tr>
            </thead>
            <tbody>
                {data.map((item) => (
                    <tr key={item.id}>
                        <td>{item.type}</td>
                        <td>{item.id}</td>                      
                        <td>{item.couplingName || item.fobName}</td>
                        <td>{item.description}</td>
                        <td>{item.canton}</td>
                        <td>{new Date(item.createDate).toISOString().slice(0, 19).replace("T", " ")}</td>
                        <td>{item.status}</td>
                        <td>{item.authorId}</td>                      
                        <td>{item.rankComponentName}</td>
                    </tr>
                ))}
            </tbody>
        </table>
       
        </div>
      
        {isDataLoaded && (
              <button className='buttonIsDeleteModal' style={{ width: "auto", marginTop:"0px" }} onClick={deleteComponents}>Удалить</button> 
        )}
        <hr className='horizontalLineModal' />
            </DialogContent>
            <DialogActions>
                <Button onClick={onCloseModal} class="buttonIsHideModal">
                    Закрыть
                </Button>
            </DialogActions>

             {/* Snackbar */}
                <Snackbar
                    anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                    }}
                    open={snackbarOpen}
                    autoHideDuration={6000}
                    onClose={handleCloseSnackbar}
                    message={snackbarMessage}
                    ContentProps={{
                        style: {
                        color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
                        }
                    }}
                    />
        </Dialog>
    );
};

export default AdminDeleteComponent;